import { Injectable } from '@angular/core';

// Went with this approach instead of the simplier
// providers: [ { provide: 'Window', useValue: window } ],
// in the injected module to keep all logic of google-analytics inside shared.
// This approach will also make it easier if we ever plan to run the app
// outside of browsers

function _window(): Window {
  // return the global native browser window object
  return window;
}

@Injectable()
export class WindowRef {
  get nativeWindow(): Window {
    return _window();
  }
}
